import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { Button } from '../components/ui/button';
import { X, QrCode } from '@phosphor-icons/react';

export default function QRScanner({ onScan, onClose }) {
  const [error, setError] = useState('');
  const [scanning, setScanning] = useState(false);
  const scannerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    let html5QrCode = null;

    const startScanner = async () => {
      try {
        html5QrCode = new Html5Qrcode('qr-reader');
        scannerRef.current = html5QrCode;
        setScanning(true);

        await html5QrCode.start(
          { facingMode: 'environment' },
          {
            fps: 10,
            qrbox: { width: 250, height: 250 },
            aspectRatio: 1.0,
          },
          (decodedText) => {
            if (onScan) onScan(decodedText);
            html5QrCode.stop().catch(() => {});
            setScanning(false);
          },
          () => {} // ignore errors during scanning
        );
      } catch (err) {
        setError('Camera access denied or QR scanner failed to start. ' + (err?.message || ''));
        setScanning(false);
      }
    };

    startScanner();

    return () => {
      if (scannerRef.current && scanning) {
        scannerRef.current.stop().catch(() => {});
      }
    };
  }, []);

  const handleClose = () => {
    if (scannerRef.current) {
      scannerRef.current.stop().catch(() => {});
    }
    if (onClose) onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black flex flex-col" data-testid="qr-scanner">
      {/* Header */}
      <div className="flex items-center justify-between p-4 bg-black/90">
        <div className="flex items-center gap-2">
          <QrCode size={20} className="text-white" />
          <span className="text-white text-sm font-medium uppercase tracking-widest">Scan Vehicle QR</span>
        </div>
        <button onClick={handleClose} className="text-white/60 hover:text-white" data-testid="qr-close-btn">
          <X size={24} />
        </button>
      </div>

      {/* Scanner */}
      <div className="flex-1 flex items-center justify-center p-4">
        {error ? (
          <div className="text-center text-white/60">
            <QrCode size={64} className="mx-auto mb-4" />
            <p className="text-sm">{error}</p>
            <Button onClick={handleClose} className="mt-4 bg-white/10 text-white hover:bg-white/20 hover:text-white rounded-none">
              Close
            </Button>
          </div>
        ) : (
          <div className="w-full max-w-md">
            <div id="qr-reader" className="w-full" ref={containerRef} />
            <p className="text-white/40 text-xs text-center mt-4 uppercase tracking-widest">
              Point camera at vehicle QR code
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
